import { useStore } from 'effector-react'
import * as React from 'react'

import { $userEditProfile, userEditProfileMounted, getUser } from './model'

export const useUserEditProfile = () => {
  let userEditProfile = useStore($userEditProfile)
  const loading = useStore(getUser.pending)

  React.useEffect(() => {
    userEditProfileMounted()
  }, [])

  return { userEditProfile, loading }
}
